/* ck-lp.js: Canape King landing pages, 20 Oct 2026.
   1. Add buttons put the item in the basket without leaving the page (POST /cart/add.js). UpCart opens its drawer on that
      request (checked live 20 Oct). If the request fails, the form posts normally and Shopify opens the basket page.
   2. The sticky bar on phones shows once the hero button has scrolled away, and hides at the closing button. */
(function () {
  if (window.ckLpReady) return;
  window.ckLpReady = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-cklp-add]')) return;
    if (!window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    var label = btn ? btn.textContent : '';
    var id = form.elements.id ? Number(form.elements.id.value) : 0;
    if (!id) { form.submit(); return; }
    if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      if (btn) btn.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('cklp:added', { detail: { id: id } }));
      setTimeout(function () { if (btn) { btn.textContent = label; btn.disabled = false; } }, 1600);
    }).catch(function () {
      if (btn) { btn.textContent = label; btn.disabled = false; }
      form.submit();
    });
  });

  function initSticky() {
    var bar = document.querySelector('[data-cklp-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('[data-cklp-hero-cta]');
    var end = document.querySelector('[data-cklp-end]');
    var heroIn = !!hero, endIn = false;
    function update() {
      var on = !heroIn && !endIn;
      bar.classList.toggle('is-on', on);
      document.body.classList.toggle('cklp-bar-on', on);
    }
    if (hero) new IntersectionObserver(function (en) { heroIn = en[0].isIntersecting; update(); }).observe(hero);
    if (end) new IntersectionObserver(function (en) { endIn = en[0].isIntersecting; update(); }).observe(end);
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSticky); else initSticky();
})();
